

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form20StatusInfoType } from '@/types/Information/Form20';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form20ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form20StatusInfoType;

}
